import React, { useContext, useState } from 'react'
import * as yup from 'yup'
import { Formik, Field } from 'formik'
import { changePassword } from 'services/user'
import FormCompleted from 'components/FormCompleted'
import { renderTextInput } from 'components/forms/SharedInputs'
import ServerError from 'steps/shared/ServerError'
const validateChangePasswordForm = yup.object().shape({
  oldPassword: yup.string().required(' ').trim(),
  newPassword: yup
    .string()
    .min(8, 'Password should be a minimum of 8 characters.')
    .required(' ')
    .trim(),
  newPasswordConfirm: yup
    .string()
    .min(8, 'Password should be a minimum of 8 characters.')
    .required(' ')
    .trim()
    .oneOf([yup.ref('newPassword'), null], "Passwords don't match"),
})

const ChangePasswordForm = () => {
  const [serverError, setserverError] = useState([])
  const [formSuccessState, setFormSuccessState] = useState(false)
  const formatServerError = obj => {
    let reason = 'Server could not change password. Please try again later.'
    if (obj.detail) {
      reason = obj.detail
    }
    return reason
  }
  const handleChangePassword = (
    oldPassword,
    newPassword,
    newPasswordConfirm,
  ) => {
    changePassword(oldPassword, newPassword, newPasswordConfirm)
      .then(result => {
        if (result.success === true) {
          setFormSuccessState(true)
        } else {
          setserverError(formatServerError(result))
        }
      })
      .catch(e => {
        setserverError(formatServerError(e))
      })
  }

  return (
    <>
      <FormCompleted
        name="checkmark"
        successText="Your password has been successfully changed!"
        isActive={formSuccessState}
      >
        <Formik
          initialValues={{
            oldPassword: '',
            newPassword: '',
            newPasswordConfirm: '',
          }}
          validateOnBlur={true}
          validateOnChange={true}
          onSubmit={values => {
            handleChangePassword(
              values.oldPassword,
              values.newPassword,
              values.newPasswordConfirm,
            )
          }}
          validationSchema={validateChangePasswordForm}
        >
          {({ values, handleSubmit, setFieldValue, errors, touched }) => {
            return (
              <form onSubmit={handleSubmit} id="changePassword">
                <ul className="form__elements" style={{ padding: '12px' }}>
                  <li className="form__element">
                    <Field
                      name="oldPassword"
                      type="password"
                      label="Old Password"
                      placeholder={'Old Password'}
                      component={renderTextInput}
                      error={errors.oldPassword}
                      shrink={true}
                      touched={touched.oldPassword && true}
                    />
                  </li>

                  <li className="form__element">
                    <Field
                      name="newPassword"
                      type="password"
                      label="New Password"
                      placeholder={'New assword'}
                      component={renderTextInput}
                      error={errors.newPassword}
                      shrink={true}
                      touched={touched.newPassword && true}
                    />
                  </li>
                  <li className="form__element">
                    <Field
                      name="newPasswordConfirm"
                      type="password"
                      label="Confirm New Password"
                      placeholder={'Confirm New Password'}
                      component={renderTextInput}
                      error={errors.newPasswordConfirm}
                      shrink={true}
                      touched={touched.newPasswordConfirm && true}
                    />
                  </li>

                  <li className="form__submit-wrapper">
                    <input
                      className="btn"
                      type="submit"
                      value="Change Password"
                    />
                  </li>
                </ul>
              </form>
            )
          }}
        </Formik>
        {serverError && <ServerError customMessage={serverError} />}
      </FormCompleted>
    </>
  )
}

export default ChangePasswordForm
